import { CircularProgress, Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import PieChart from "../../../app/component/features/pieChart";
import { HomeTableEquipmentType } from "../../../app/stores/homeTableEquipmentStore";
import { useStore } from "../../../app/stores/store";

function HomeTableEquipmentChart() {
  const { selectedStation } = useStore().commonStore
  const { getChart, chart, loadingChart } = useStore().homeTableEquipmentStore
  
  useEffect(() => {
    if (selectedStation) {
      getChart(selectedStation.id, HomeTableEquipmentType.maintainability);
      getChart(selectedStation.id, HomeTableEquipmentType.reliability);
      getChart(selectedStation.id, HomeTableEquipmentType.availability);
    }
  }, [getChart, selectedStation])

  return (
    <Stack direction="row" spacing={2} justifyContent="space-around">
      {loadingChart.reliability 
        ? <CircularProgress />
        : <PieChart title={chart.reliability?.title ?? ''} data={chart.reliability?.data} />}
      {loadingChart.availability 
        ? <CircularProgress />
        : <PieChart title={chart.availability?.title ?? ''} data={chart.availability?.data} />}
      {loadingChart.maintainability 
        ? <CircularProgress />
        : <PieChart title={chart.maintainability?.title ?? ''} data={chart.maintainability?.data} />}
    </Stack>
  )
}

export default observer(HomeTableEquipmentChart)